const KEY_PREFIX = "cleared-before:";

/** Returns the cutoff timestamp (ms) below which messages should be hidden on
 * this device, or null if the conversation has never been locally cleared. */
export function getClearedBeforeTimestamp(conversationId: string): number | null {
  const raw = localStorage.getItem(KEY_PREFIX + conversationId);
  if (!raw) return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}

export function setClearedBeforeTimestamp(conversationId: string, timestampMs: number) {
  localStorage.setItem(KEY_PREFIX + conversationId, String(timestampMs));
}

export function clearClearedBeforeTimestamp(conversationId: string) {
  localStorage.removeItem(KEY_PREFIX + conversationId);
}
